// ID-only refresh hints. Each tab reads its own authorized tenant APIs.
const keyFor = tenant => `bd-finance-change:v1:${encodeURIComponent(tenant)}`;
export function publishFinanceChange(tenant, environment = window) {
  if (typeof tenant !== "string" || !tenant.trim()) return;
  const key = keyFor(tenant), hint = { version: 1, nonce: `${Date.now()}:${Math.random()}` };
  let channel;
  try { channel = new environment.BroadcastChannel(key); channel.postMessage(hint); } catch { /* Storage and polling remain available. */ }
  finally { channel?.close(); }
  try { environment.localStorage.setItem(key, JSON.stringify(hint)); } catch { /* Polling remains authoritative. */ }
  environment.dispatchEvent(new CustomEvent(key, { detail: hint }));
}

export function watchFinanceChanges(tenant, refresh, environment = window) {
  if (!tenant) return () => {};
  const key = keyFor(tenant), seen = new Set();
  let channel;
  const receive = hint => {
    if (hint?.version !== 1 || typeof hint.nonce !== "string" || !hint.nonce || hint.nonce.length > 150 || seen.has(hint.nonce)) return;
    seen.add(hint.nonce); if (seen.size > 64) seen.delete(seen.values().next().value);
    refresh();
  };
  const local = event => receive(event.detail);
  const storage = event => { if (event.key === key && event.newValue) { try { receive(JSON.parse(event.newValue)); } catch { /* Ignore malformed hints. */ } } };
  try { channel = new environment.BroadcastChannel(key); channel.onmessage = event => receive(event.data); } catch { /* Storage/polling fallback. */ }
  environment.addEventListener(key, local); environment.addEventListener("storage", storage);
  return () => {
    environment.removeEventListener(key, local); environment.removeEventListener("storage", storage);
    if (channel) { channel.onmessage = null; channel.close(); }
  };
}
